import React from 'react';

import cn from 'classnames';

import { Flex, Input } from '@shared/ui';

import cls from './InvoiceFields.module.css';

interface IInvoiceFieldsProps {
    companyName: string;
    innKpp: string;
    handleCompanyNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleInnKppChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
}
export const InvoiceFields = ({
    className,
    companyName,
    innKpp,
    handleInnKppChange,
    handleCompanyNameChange,
}: IInvoiceFieldsProps) => (
    <Flex gap={8} className={cn(cls.InvoiceFieldsContainer, className)}>
        <Input
            value={companyName}
            onChange={handleCompanyNameChange}
            classes={[cls.invoiceField, cls.companyField]}
            placeholder="Наименование компании"
        />
        <Input
            value={innKpp}
            onChange={handleInnKppChange}
            classes={[cls.invoiceField, cls.innField]}
            placeholder="ИНН/КПП компании"
        />
    </Flex>
);
